import React, { useCallback, useEffect, useState } from 'react';
import { Row, Col } from 'antd';

import OnTraccrTextInput from '../common/inputs/OnTraccrTextInput';
import OnTraccrCheckbox from '../common/inputs/OnTraccrCheckbox';

export default ({
  onChange,
  value,
  initialValue,
}) => {
  const [showTextInput, setShowTextInput] = useState(!!initialValue);
  const onCheckChange = useCallback((e) => {
    setShowTextInput(e);
    if (!e) onChange(null);
  },[onChange]);
  useEffect(() => {
    setShowTextInput(!!initialValue);
  },[]);
  return (
    <>
      <Row gutter={10} style={{ height: 32, paddingLeft: 5 }} align='middle'>
        <Col>
          <OnTraccrCheckbox
            onChange={onCheckChange}
            value={showTextInput}
            label="Requires PIN to lock/unlock?"
          />
        </Col>
        <Col flex='auto'>
        {showTextInput &&
          <OnTraccrTextInput
            onChange={onChange}
            value={value}
            password
          />
        }
        </Col>
      </Row>
    </>
  );
}